import { createStore } from "@stencil/store";

export const common = createStore({
    logo: "",
    categoryUrl: "",

    cartLink: "",
    heartLink: "",
    accountLink: "",
    loginLink: "",
    logoutLink: "",
    registerLink: "",
    softwareLink: "",

    promo: "",
    promoLink: "",

    email: "",
    phone: "",
    workingHours: "",
    company: "",
    address: "",
    address2: "",
    nip: "",
    regon: "",
    mapAddress: "",

    newsletterPopup: false,

    newsletterApi: "",
    suggestionApi: "",
    autocompleteApi: "",

    cookieMessage: "",
    cookieButton: "",
    cookieDelay: 1000,

    categories: [],

    social: [],
    reviewers: [],
    footerLinks: [],

    translations: {}
    
} as CommonData);

export interface CommonData {
    preload: boolean;
    logo: string;
    categoryUrl: string;

    cartLink: string;
    heartLink: string;
    accountLink: string;
    loginLink: string;
    logoutLink: string;
    registerLink: string;
    softwareLink: string;

    promo?: string;
    promoLink?: string;

    email: string;
    phone: string;
    workingHours: string;
    company: string;
    address: string;
    address2: string;
    nip: string;
    regon: string;
    mapAddress: string;

    newsletterPopup: boolean;
    newsletterSideButton: boolean;

    newsletterApi: string;
    suggestionApi: string;
    autocompleteApi: string;

    cookieMessage: string;
    cookieButton: string;
    cookieDelay: 1000;

    categories: Category[];

    social: FooterImageLink[];
    reviewers: FooterImageLink[];
    footerLinks: FooterLinkSection[];

    api: CommonApi;
    translations: Translations;
    topNotice: TopNotice;
    developmentWarning: string;

    language: Language;
    languages: Language[];
    languageDomainChange: boolean;
    
    currency: Currency;
    currencies: Currency[];
}

export interface ReviewAverage {
    href: string;
    message: string;
    reviews: number;
    months: number;
    totalReviews: number;
    average: number;
    example: string;
}

export interface ReviewProduct {
    review: string;
    rating: number;
    date: string;
}

export interface CommonApi {
    addToCart: string;
    addToFavourites: string;
    removeFromFavourites: string;
}

export interface Translations {
    addToCart: string;
    unavailable: string;
    seeMore: string;
    countUnit: string;

    navbarButtonLanguage: string;
    navbarButtonContact: string;
    navbarButtonAccount: string;
    navbarButtonFav: string;
    navbarButtonCart: string;
    navbarButtonLogin: string;
    navbarButtonLogout: string;
    navbarButtonMenu: string;
    
    navbarCategories: string;
    panelLanguage: string;
    panelCurrency: string;

    newsletterSideLeft: string;
    newsletterSideRight: string;

    newsletterPopupHeadingTop: string;
    newsletterPopupHeadingTopSize: string;
    newsletterPopupHeadingBottom: string;
    newsletterPopupHeadingBottomSize: string;
    newsletterPopupMessage: string;
    newsletterPopupEmail: string;
    newsletterPopupName: string;
    newsletterPopupAgreement: string;
    newsletterPopupSubmit: string;
    newsletterPopupSuccessHeading: string;
    newsletterPopupSuccessMessage: string;
    newsletterPopupFailureHeading: string;
    newsletterPopupFailureMessage: string;

    footerContact: string;
    footerSoftware: string;
    footerNewsletterSmall: string;
    footerNewsletterLarge: string;
    footerNewsletterSubmit: string;

    suggestionAddedToCart: string;
    suggestionGoToCart: string;
    suggestionContinueBrowsing: string;

    sorting: string;
    sortingRecommended: string;
    sortingPopular: string;
    sortingNewest: string;
    sortingCheapest: string;
    sortingExpensive: string;

    filter: string;
    filteringHeader: string;
    filteringClear: string;
    filteringSubmit: string;

    noContentHome: string;
    noContentBack: string;

    inputSubmitForm: string;
    inputFieldRequired: string;
    inputConnectionError: string;
    inputInternetConnectionError: string;
    inputRefresh: string;
    inputIncorrectEmail: string;
    inputPasswordsDontMatch: string;
    inputFieldsDontMatch: string;
    inputOnlyNumbers: string;
    inputOnlyPricesWithoutCurrency: string;
    inputMinCharacters: string; // {count} gets replaced with a value
    inputMaxCharacters: string; // {count} gets replaced with a value
}
export interface Category {
    name: string;
    url: string;
    image?: CategoryImage;
    children?: Category[];
    deep?: boolean;
}

export interface CategoryImage {
    url: string;
    width: number;
    height: number;
}

export interface TopNotice {
    name: string;
    link: string;
    image: string;
    color: string;
    textColor: string;
    message: string;
}

export interface NavbarTheme {
    navbarColor: string,
    navbarColorHover: string,
    navbarColorActive: string,
    categoryColor: string,
    categoryColorHover: string,
    categoryColorActive: string,
    categoryColorBackdrop: string
}

export interface InfoBannerData {
    image: string;
    webp: string;
    width: number;
    height: number;
    color: string;
    name: string;
    link: string;
    theme: NavbarTheme;
}

export interface FooterImageLink {
    name: string;
    link: string;
    image: string;
    width: number;
    height: number;
}

export interface FooterLink {
    name: string;
    link: string;
}

export interface FooterLinkSection {
    name: string;
    items: FooterLink[];
}

export interface Language {
    id: number;
    code: string;
    name: string;
    flag: string;
    domain: string;
}

export interface Currency {
    id: number;
    name: string;
    code: string;
    symbol: string;
    separator: string;
}